import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useGetBackendVersionQuery } from '@api/oqulyqtarApi/VersionService.js';

const FRONTEND_VERSION = import.meta.env.VITE_VERSION || '';

function About(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { data: backendVersion } = useGetBackendVersionQuery();

    const version = backendVersion
        ? `${FRONTEND_VERSION}.${backendVersion.version}`
        : FRONTEND_VERSION;

    return (
      <div className='tablet:w-1/2 text-footer-text text-sm flex flex-col mb-4 order-1 tablet:order-2 mx-2'>
          <p className='font-bold mb-2'>{t('general.footer.aboutProject')}</p>
          <p className='mb-1'>Информация о приложении</p>
          <p className='mb-1'>{t('general.footer.termsOfUse')}</p>
          <p className=''>Версия {version}</p>
      </div>
    );
}

export default memo(About);
